(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grecook-homepage"] && !Shopify.designMode) return;
  try {
    
function grecookSyncNavHeight(){
  document.querySelectorAll('.grecook-home').forEach(home => {
    const header = home.querySelector('.gc-nav-header');
    if (!header) return;
    const update = () => home.style.setProperty('--gc-nav-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    update();
    if (!header.dataset.gcHeightObserved) {
      header.dataset.gcHeightObserved = 'true';
      new ResizeObserver(update).observe(header);
    }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', grecookSyncNavHeight, { once: true });
else grecookSyncNavHeight();
document.addEventListener('shopify:section:load', grecookSyncNavHeight);

if (!window.grecookMegaBound) {
  window.grecookMegaBound = true;
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    const summary = event.target.closest('.gc-fan-mega > summary');
    if (summary) {
      document.querySelectorAll('.gc-fan-mega[open]').forEach(menu => { if (menu !== summary.parentElement) menu.open = false; });
      summary.parentElement.open = true;
    }
  });
  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    const menu = event.target.closest('.gc-fan-mega');
    if (menu && !menu.contains(event.relatedTarget) && !menu.contains(document.activeElement)) menu.open = false;
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.gc-fan-mega > summary');
    if (trigger) document.querySelectorAll('.gc-fan-mega[open]').forEach(menu => { if (menu !== trigger.parentElement) menu.open = false; });
    document.querySelectorAll('.gc-fan-mega[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.gc-fan-mega[open]').forEach(menu => {
      const restoreFocus = menu.contains(document.activeElement);
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('focusout', (event) => {
    if (!window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    if (!(event.relatedTarget instanceof Node)) return;
    const menu = event.target.closest('.gc-fan-mega');
    if (menu && !menu.contains(event.relatedTarget)) menu.open = false;
  });
}

function grecookInitCarousels() {
  document.querySelectorAll('[data-gc-carousel]').forEach(root => {
    if (root.gcCarousel) return;
    const slides = Array.from(root.querySelectorAll('[data-gc-slide]'));
    const controls = root.querySelector('[data-gc-controls]');
    const dotContainer = root.querySelector('[data-gc-dots]');
    const dots = slides.map((slide, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
      button.addEventListener('click', () => { show(i); schedule(); });
      dotContainer.appendChild(button);
      return button;
    });
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, timer = null, hovering = false, editing = false;
    const interval = Math.max(3000, Number(root.dataset.interval) || 5000);
    const stop = () => { if (timer !== null) clearInterval(timer); timer = null; };
    const schedule = () => {
      stop();
      if (slides.length > 1 && root.dataset.autoplay === 'true' && !hovering && !editing && !motion.matches && !document.hidden && !root.contains(document.activeElement)) {
        timer = setInterval(() => show(index + 1), interval);
      }
    };
    const show = next => {
      index = (next + slides.length) % slides.length;
      root.dataset.gcText = slides[index].dataset.gcText;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        slide.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
        if (!active) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    };
    const previous = () => { show(index - 1); schedule(); };
    const next = () => { show(index + 1); schedule(); };
    root.querySelector('[data-gc-prev]').addEventListener('click', previous);
    root.querySelector('[data-gc-next]').addEventListener('click', next);
    root.addEventListener('mouseenter', () => { hovering = true; stop(); });
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) queueMicrotask(schedule); });
    root.addEventListener('keydown', event => {
      if (event.target.matches('input, textarea, select')) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); next(); }
    });
    let touch = null;
    root.addEventListener('touchstart', event => {
      if (event.touches.length !== 1 || event.target.closest('button, a, video')) { touch = null; return; }
      touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    root.addEventListener('touchend', event => {
      if (!touch || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touch.x;
      const dy = event.changedTouches[0].clientY - touch.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { if (dx < 0) next(); else previous(); }
      touch = null;
    }, { passive: true });
    const visibility = () => schedule();
    const motionChanged = () => schedule();
    document.addEventListener('visibilitychange', visibility);
    motion.addEventListener('change', motionChanged);
    root.gcCarousel = {
      select(blockId) { const selected = slides.findIndex(slide => slide.dataset.blockId === blockId); if (selected >= 0) { editing = true; stop(); show(selected); } },
      deselect() { editing = false; schedule(); },
      destroy() { stop(); document.removeEventListener('visibilitychange', visibility); motion.removeEventListener('change', motionChanged); }
    };
    controls.hidden = slides.length < 2;
    show(0);
    schedule();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', grecookInitCarousels, { once: true });
else grecookInitCarousels();
document.addEventListener('shopify:section:load', grecookInitCarousels);
document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-gc-carousel]').forEach(root => root.gcCarousel?.destroy()); });
document.addEventListener('shopify:block:select', event => { event.target.closest('[data-gc-carousel]')?.gcCarousel?.select(event.detail.blockId); });
document.addEventListener('shopify:block:deselect', event => { event.target.closest('[data-gc-carousel]')?.gcCarousel?.deselect(); });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grecook-new-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('grecook-new-product')){
customElements.define('grecook-new-product',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const main=this.querySelector('.gnp-main'),dialog=this.querySelector('dialog');
this.querySelectorAll('[data-gnp-thumb]').forEach(button=>button.addEventListener('click',()=>{
main.srcset='';main.src=button.dataset.src;main.alt=button.dataset.alt;
this.querySelectorAll('[data-gnp-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
}));
this.querySelector('[data-gnp-zoom]')?.addEventListener('click',()=>{dialog.querySelector('img').src=main.currentSrc||main.src;dialog.querySelector('img').alt=main.alt;dialog.showModal();});
this.querySelector('[data-gnp-close]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
this.querySelector('[data-gnp-variant]')?.addEventListener('change',e=>{const url=new URL(location.href);url.searchParams.set('variant',e.target.value);location.assign(url);});
const source=this.querySelector('.gnp-description');
if(source){
const p=[...source.querySelectorAll('p')].find(p=>p.textContent.trim());
if(p){const target=this.querySelector('.gnp-summary'),title=this.querySelector('.gnp-heading h1')?.textContent.trim().toLowerCase(),text=p.textContent.trim();if(text.toLowerCase()===title){p.hidden=true;}else if(target.hidden){target.textContent=text;target.hidden=false;p.hidden=true;}}
const heading=[...source.querySelectorAll('h2,h3')].find(h=>/^(features|key features|highlights|about this item)$/i.test(h.textContent.trim()));
const list=heading?.nextElementSibling;
if(list?.tagName==='UL'){const target=this.querySelector('.gnp-highlights');if(target.hidden){[...list.children].forEach(li=>target.querySelector('ul').append(li.cloneNode(true)));target.hidden=false;heading.hidden=true;list.hidden=true;}}
const spec=[...source.querySelectorAll('h2,h3')].find(h=>/^(specifications|technical specifications|key specifications)$/i.test(h.textContent.trim()))?.nextElementSibling;
if(spec&&['TABLE','UL','DL'].includes(spec.tagName)){const target=this.querySelector('.gnp-key');if(target.hidden){target.append(spec.cloneNode(true));target.hidden=false;spec.hidden=true;spec.previousElementSibling.hidden=true;}}
}
this.querySelector('[data-gnp-now]')?.addEventListener('click',async e=>{
const form=e.target.closest('form');if(!form.reportValidity())return;
const buttons=[...form.querySelectorAll('button')],error=form.querySelector('.gnp-error');
buttons.forEach(b=>b.disabled=true);error.hidden=true;
try{const root=window.Shopify?.routes?.root||'/';const response=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||this.dataset.error);location.assign(root+'checkout');}
catch(err){error.textContent=err.message||this.dataset.error;error.hidden=false;buttons.forEach(b=>b.disabled=false);}
});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
